/**
 * How far past each handle the curve's tangent reaches. The Figma card gap is
 * 28px, so a bezier whose control points sit at the gap's midpoint (React
 * Flow's default) collapses into a near-vertical line with hooked ends, and a
 * step path has no room for a corner radius — it renders as a square bracket.
 * A wider tangent lets the line leave and enter horizontally and cross the
 * gap in one swoop. Between cards on the same line the control points fall on
 * the line itself, so the path is straight.
 */
const MIN_TANGENT_PX = 36;

export const ruleGraphFlowEdgePath = ({
  sourceX,
  sourceY,
  targetX,
  targetY,
}: {
  sourceX: number;
  sourceY: number;
  targetX: number;
  targetY: number;
}): string => {
  const tangent = Math.max(Math.abs(targetX - sourceX) / 2, MIN_TANGENT_PX);
  return `M ${sourceX},${sourceY} C ${sourceX + tangent},${sourceY} ${
    targetX - tangent
  },${targetY} ${targetX},${targetY}`;
};
